
<script>
    import Checkbox from '../content/common/PrimeVue/Checkbox.vue'
    import {propertyListHeight} from "../administration/user/data/variables";
    import Template from "../content/elements/template.vue";
    import HeaderCheckbox from "../content/common/PrimeVue/HeaderCheckbox.vue";
    import TextField from "./text-field.vue";
    export default {
        name: 'property-table',
        components: {TextField, HeaderCheckbox, Template, Checkbox},
        props: {
            items: Array,
            readOnly: Boolean,
            disableSelectAll: Boolean,
            disableHeader: Boolean,
            searchable: Boolean,
            sorted: Boolean,
            showSelCount: Boolean,
            propertyName: {
                type: String,
                default: 'Name'
            },
            providedMaxHeight: Number,
            errorMessage: String
        },
        data() {
            return {
                expanded: [],
                search: undefined
            }
        },
        computed: {
            maxHeight() {
                return propertyListHeight;
            },
            allSelected() {
                return this.items.every(item => item.selected);
            },
            tMessage() {
                return Lang.langGet('Select');
            },
            tEmptyList() {
                return Lang.langGet('No :name exists or matches the criteria...', {name: this.propertyName})
            },
            tSearch() {
                return Lang.langGet('Search');
            },
            filteredItems() {
                let items = this.items;
                if (this.sorted) {
                    items = this.items.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
                }
                if (!this.search) return items;

                return items.filter(item => {
                    const name = item.name.normalize("NFD").toLowerCase();
                    const compare = this.search.normalize("NFD").toLowerCase();
                    return name.includes(compare);
                });
            },
            selectedCount() {
                return this.items.filter(item => item.selected).length;
            },
            selectedInfo() {
                return '['+ this.selectedCount + '/'+ this.items.length+ ']';

            }
        },
        methods: {
            handleEmit(item, selected, isChild) {
                if (item.children?.length >= 1) {
                    this.$emit('input', {
                        ...item,
                        selected
                    }, isChild);
                }
            },
            handleCheckboxClicked(item, isChild) {
                let selected = item?.selected;
                if (selected !== undefined) {
                    this.$emit('input', {...item, selected}, isChild);
                }
            },
            handleCollapse(item) {
                const index = this.expanded.findIndex(c => c === (item.name || item.text));
                if (index >= 0) {
                    this.expanded.splice(index, 1);
                } else {
                    this.expanded.push((item.name || item.text));
                }
            },
            isExpanded(item) {
                return this.expanded.some(c => c === (item.name || item.text));
            },
            getChevron(item) {
                return this.isExpanded(item) ? 'fa-chevron-down' : 'fa-chevron-right';
            },
            isArray(arr) {
                return _.isArray(arr);
            },
            hasChildren(item) {
                return item.children?.length;
            },
            propertyRowListClass(item) {
                const shadow = (this.hasChildren(item) && this.isExpanded(item)) ? 'property-list-box-shadow' : '';
                return `property-list-row py-1 ${shadow}`;
            }
        }
    }
</script>

<template>
    <div class="property-list-container">
        <div v-if="!disableHeader" class="property-list-row-header elevation-2">
            <div class="d-flex flex-row align-center">
                <strong>{{propertyName}}</strong>
                <div class="bg-danger rounded mx-2 px-2 text-center" v-if="errorMessage">{{errorMessage}}</div>
                <div class="property-list-search ml-4 mt-1" v-if="searchable && !errorMessage">
                    <text-field
                        :label="tSearch"
                        :value="search"
                        clearable
                        @input="val => search = val"
                    />
                </div>
            </div>
            <div>
                <strong v-if="showSelCount">
                    {{selectedInfo}}
                </strong>
                <checkbox class="ml-2" v-if="!readOnly && !disableSelectAll && items.length"
                    :binary="true"
                    :modelValue="allSelected"
                    @input="$emit('selectAll', allSelected)"
                />
            </div>
        </div>
        <div class="property-list-body mt-2 pr-1">
            <strong class="d-flex align-center justify-center" v-if="!filteredItems.length">
                {{tEmptyList}}
            </strong>
            <template v-for="item in filteredItems">
                <div>
                    <div :class="propertyRowListClass(item)" @click="!(item.children?.length)?handleCheckboxClicked(item, false):null">
                        <div class="property-list-row-header-text align-center overflow-x-hidden" @click="(item.children?.length)?handleCollapse(item):null">
                            <i v-if="item.children?.length"
                               :class="`actionbar-icon mr-1 fa-light ${getChevron(item)} fa-fw fa-lg`"
                            />
                            {{ item.name || item.text }}
                        </div>
                        <HeaderCheckbox v-if="!readOnly"
                            :selectMessage="tMessage"
                            :checked="item.selected"
                            :indeterminate="item.someSelected && !item.selected"
                            small
                            @change="({checked}) => handleEmit(item, checked)"
                        />
                    </div>
                    <template v-if="isExpanded(item)" v-for="child in item.children">
                        <div v-if="isArray(child)">
                            <div class="d-flex flex-row ml-6">
                                <div class="d-flex flex-column w-50">
                                    {{child[0]?.name || child[0]?.text || child[0]}}
                                </div>
                                <div class="d-flex flex-column w-50">
                                    {{child[1]?.name || child[1]?.text || child[1]}}
                                </div>
                            </div>
                        </div>
                        <div v-else class="property-list-row py-1 pl-1" @click="handleCheckboxClicked(child, true)">
                            <div class="ml-6">
                                {{ child.name || child.text }}
                            </div>
                            <checkbox v-if="!readOnly"
                                :binary="true"
                                :modelValue="child.selected"
                            />
                        </div>
                    </template>
                </div>
            </template>
        </div>
    </div>
</template>

<style>
    .property-list-container {
        overflow: hidden;
        display: flex;
        flex-direction: column;
    }

    .property-list-box-shadow {
        background-color: whitesmoke;
    }

    .property-list-row-header-text {
        width: 100%;
    }

    .property-list-row:hover {
        cursor: pointer;
        background-color: lightgrey;
    }

    .property-list-body {
        overflow-y: auto;
        height: 100%;
    }

    .property-list-row {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }

    .property-list-row-header {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding-right: 4px; /*10px for edit user*/
        padding-bottom: 4px;

    }

    @supports (-moz-appearance:none) {
        .property-list-row-header {
            padding-right: 4px;
        }
    }

    .property-list-search {
        width: 250px;
    }

    .property-list-search .v-text-field__details {
        display: none !important;
    }
</style>
